import clsx from 'clsx';
import type { ReactNode } from 'react';

import './Scroller.scss';

interface ScrollerProps {
  children: ReactNode;
  className?: string;
  scrollBarVisableOnHover?: boolean;
  stableGutter?: boolean;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

export function Scroller({
  children,
  className,
  scrollBarVisableOnHover = false,
  stableGutter = false,
  onScroll,
}: ScrollerProps) {
  const scrollerClassName = clsx('Scroller', className, {
    Scroller__visablebar: !scrollBarVisableOnHover,
    Scroller__hidebar: scrollBarVisableOnHover,
    'Scroller__stable-gutter': stableGutter,
  });
  return (
    <div className={scrollerClassName} onScroll={onScroll}>
      {children}
    </div>
  );
}
